var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["Trans"]: () => (__WEBPACK_EXTERNAL_MODULE_react_i18next_31085753__.Trans), ["initReactI18next"]: () => (__WEBPACK_EXTERNAL_MODULE_react_i18next_31085753__.initReactI18next), ["useTranslation"]: () => (__WEBPACK_EXTERNAL_MODULE_react_i18next_31085753__.useTranslation) });